var render = function () {
  var this$1 = this
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { attrs: { id: "report-new" } },
    [
      _c(
        "AppBreadCrumb",
        {
          attrs: {
            paths: [{ title: _vm.$t("report.detailReport") }],
            select: true,
          },
        },
        [
          _c(
            "select",
            {
              directives: [
                {
                  name: "model",
                  rawName: "v-model",
                  value: _vm.customDateFilter,
                  expression: "customDateFilter",
                },
              ],
              attrs: { id: "time-select" },
              on: {
                change: function ($event) {
                  var $$selectedVal = Array.prototype.filter
                    .call($event.target.options, function (o) {
                      return o.selected
                    })
                    .map(function (o) {
                      var val = "_value" in o ? o._value : o.value
                      return val
                    })
                  _vm.customDateFilter = $event.target.multiple
                    ? $$selectedVal
                    : $$selectedVal[0]
                },
              },
            },
            [
              _c("option", { attrs: { value: "today" } }, [
                _vm._v(_vm._s(_vm.$t("time.today"))),
              ]),
              _vm._v(" "),
              _c("option", { attrs: { value: "yesterday" } }, [
                _vm._v(_vm._s(_vm.$t("time.yesterday"))),
              ]),
              _vm._v(" "),
              _c("option", { attrs: { value: "current-week" } }, [
                _vm._v(
                  "\n                " +
                    _vm._s(_vm.$t("time.currentWeek")) +
                    "\n            "
                ),
              ]),
              _vm._v(" "),
              _c("option", { attrs: { value: "last-week" } }, [
                _vm._v(_vm._s(_vm.$t("time.lastWeek"))),
              ]),
              _vm._v(" "),
              _c("option", { attrs: { value: "current-month" } }, [
                _vm._v(
                  "\n                " +
                    _vm._s(_vm.$t("time.currentMonth")) +
                    "\n            "
                ),
              ]),
              _vm._v(" "),
              _vm._l(_vm.getLast11Months(), function (m, i) {
                return _c("option", { key: i, domProps: { value: m.date } }, [
                  _vm._v(
                    "\n                " + _vm._s(m.name) + "\n            "
                  ),
                ])
              }),
              _vm._v(" "),
              _c("option", { attrs: { value: "custom" } }, [
                _vm._v(
                  "\n                " +
                    _vm._s(_vm.$t("time.custom")) +
                    "\n            "
                ),
              ]),
            ],
            2
          ),
        ]
      ),
      _vm._v(" "),
      _c(
        "b-container",
        { staticClass: "my-3", attrs: { fluid: "" } },
        [
          _c(
            "b-row",
            { staticClass: "mb-3" },
            [
              _vm.customDateFilter === "custom"
                ? _c(
                    "b-col",
                    { attrs: { lg: "2" } },
                    [
                      _c(
                        "b-form-group",
                        { staticClass: "mb-1" },
                        [
                          _c("datetime", {
                            attrs: {
                              "max-datetime": _vm.maxDate,
                              "min-datetime": _vm.minDate,
                              placeholder: _vm.$t("message.startDate"),
                              auto: "",
                              "input-class": "form-control rounded-0",
                              type: "datetime",
                            },
                            model: {
                              value: _vm.startDate,
                              callback: function ($$v) {
                                _vm.startDate = $$v
                              },
                              expression: "startDate",
                            },
                          }),
                        ],
                        1
                      ),
                    ],
                    1
                  )
                : _vm._e(),
              _vm._v(" "),
              _vm.customDateFilter === "custom"
                ? _c(
                    "b-col",
                    { attrs: { lg: "2" } },
                    [
                      _c(
                        "b-form-group",
                        { staticClass: "mb-1" },
                        [
                          _c("datetime", {
                            attrs: {
                              "max-datetime": _vm.maxDate,
                              "min-datetime": _vm.minDate,
                              placeholder: _vm.$t("message.endDate"),
                              auto: "",
                              "input-class": "form-control rounded-0",
                              type: "datetime",
                            },
                            model: {
                              value: _vm.endDate,
                              callback: function ($$v) {
                                _vm.endDate = $$v
                              },
                              expression: "endDate",
                            },
                          }),
                        ],
                        1
                      ),
                    ],
                    1
                  )
                : _vm._e(),
              _vm._v(" "),
              _c(
                "b-col",
                { attrs: { lg: _vm.customDateFilter === "custom" ? 6 : 6 } },
                [
                  _c(
                    "div",
                    { staticClass: "d-flex" },
                    [
                      _vm.selectedUsers.length === 0
                        ? _c("md-chip", { staticClass: "md-primary" }, [
                            _vm._v(
                              "\n                        " +
                                _vm._s(_vm.$t("message.allRepresentatives")) +
                                "\n                    "
                            ),
                          ])
                        : _vm._e(),
                      _vm._v(" "),
                      _vm._l(_vm.getSelectedUsers(), function (user) {
                        return _c(
                          "md-chip",
                          {
                            key: user._id,
                            staticClass: "md-primary",
                            attrs: { "md-deletable": "" },
                            on: {
                              "md-delete": function ($event) {
                                return _vm.removeUser(user._id)
                              },
                            },
                          },
                          [
                            _vm._v(
                              "\n                        " +
                                _vm._s(_vm.capitalize(user.name)) +
                                "\n                    "
                            ),
                          ]
                        )
                      }),
                      _vm._v(" "),
                      !_vm.autoCompleteShow &&
                      _vm.usersFilter.data.filter(function (x) {
                        return !_vm.selectedUsers.includes(x._id)
                      }).length
                        ? _c(
                            "md-chip",
                            {
                              staticClass: "md-accent",
                              attrs: { "md-clickable": "" },
                              on: { click: _vm.openAutoComplete },
                            },
                            [
                              _vm._v(
                                "\n                        + " +
                                  _vm._s(_vm.$t("message.addRepresentative")) +
                                  "\n                    "
                              ),
                            ]
                          )
                        : _vm._e(),
                      _vm._v(" "),
                      _vm.autoCompleteShow
                        ? _c(
                            "md-autocomplete",
                            {
                              staticClass: "ml-3",
                              attrs: {
                                "md-fuzzy-search": true,
                                "md-open-on-focus": true,
                                "md-options": _vm.usersFilter.data.filter(
                                  function (x) {
                                    return !_vm.selectedUsers.includes(x._id)
                                  }
                                ),
                                autofocus: "",
                                "md-input-id": "acUsers",
                              },
                              on: { "md-selected": _vm.autoCompleteSelected },
                              scopedSlots: _vm._u(
                                [
                                  {
                                    key: "md-autocomplete-item",
                                    fn: function (ref) {
                                      var item = ref.item
                                      var term = ref.term
                                      return [
                                        _c(
                                          "div",
                                          {
                                            staticStyle: {
                                              display: "flex",
                                              "align-items": "center",
                                              "font-size": "16px",
                                            },
                                          },
                                          [
                                            _c("Avatar", {
                                              staticClass: "mr-2",
                                              staticStyle: { color: "white" },
                                              attrs: {
                                                size: 40,
                                                username: item.name,
                                              },
                                            }),
                                            _vm._v(" "),
                                            _c(
                                              "md-highlight-text",
                                              { attrs: { "md-term": term } },
                                              [
                                                _vm._v(
                                                  "\n                                    " +
                                                    _vm._s(
                                                      _vm.capitalize(item.name)
                                                    ) +
                                                    "\n                                "
                                                ),
                                              ]
                                            ),
                                          ],
                                          1
                                        ),
                                      ]
                                    },
                                  },
                                  {
                                    key: "md-autocomplete-empty",
                                    fn: function (ref) {
                                      var term = ref.term
                                      return [
                                        _vm._v(
                                          "\n                            " +
                                            _vm._s(
                                              _vm.$t(
                                                "message.noRePresentativeFound"
                                              )
                                            ) +
                                            "\n                        "
                                        ),
                                      ]
                                    },
                                  },
                                ],
                                null,
                                false,
                                917718590
                              ),
                              model: {
                                value: _vm.autoComploteValue,
                                callback: function ($$v) {
                                  _vm.autoComploteValue = $$v
                                },
                                expression: "autoComploteValue",
                              },
                            },
                            [
                              _c("label", [
                                _vm._v(_vm._s(_vm.$t("message.selectRep"))),
                              ]),
                            ]
                          )
                        : _vm._e(),
                    ],
                    2
                  ),
                ]
              ),
            ],
            1
          ),
          _vm._v(" "),
          !_vm.loading
            ? _c(
                "div",
                [
                  _c(
                    "b-row",
                    [
                      _c("b-col", { attrs: { lg: "4" } }, [
                        _c(
                          "div",
                          {
                            staticClass: "box yes-hover",
                            on: {
                              click: function ($event) {
                                _vm.tabIndex = 0
                              },
                            },
                          },
                          [
                            _c("p", { staticClass: "label" }, [
                              _vm._v(
                                "\n                            " +
                                  _vm._s(_vm.$t("message.totalConnected")) +
                                  "\n                        "
                              ),
                            ]),
                            _vm._v(" "),
                            _c("p", { staticClass: "value" }, [
                              _vm._v(
                                "\n                            " +
                                  _vm._s(_vm.statistics.totalValidChatCount) +
                                  "\n                        "
                              ),
                            ]),
                          ]
                        ),
                        _vm._v(" "),
                        _c(
                          "div",
                          {
                            staticClass: "box yes-hover",
                            on: {
                              click: function ($event) {
                                _vm.tabIndex = 4
                              },
                            },
                          },
                          [
                            _c("p", { staticClass: "label" }, [
                              _vm._v(
                                "\n                            " +
                                  _vm._s(_vm.$t("message.distConversation")) +
                                  "\n                        "
                              ),
                            ]),
                            _vm._v(" "),
                            _c("p", { staticClass: "value" }),
                          ]
                        ),
                        _vm._v(" "),
                        _c(
                          "div",
                          {
                            staticClass: "box yes-hover",
                            on: {
                              click: function ($event) {
                                _vm.tabIndex = 20
                              },
                            },
                          },
                          [
                            _c("p", { staticClass: "label" }, [
                              _vm._v(_vm._s(_vm.$t("message.videoCallDist"))),
                            ]),
                            _vm._v(" "),
                            _c("p", { staticClass: "value" }),
                          ]
                        ),
                        _vm._v(" "),
                        _c(
                          "div",
                          {
                            staticClass: "box yes-hover",
                            on: {
                              click: function ($event) {
                                _vm.tabIndex = 1
                              },
                            },
                          },
                          [
                            _c("p", { staticClass: "label" }, [
                              _vm._v(
                                "\n                            " +
                                  _vm._s(
                                    _vm.$t("message.avgRating", {
                                      count: _vm.totalRateCount(),
                                      point: _vm.statistics.avgRate,
                                    })
                                  ) +
                                  "\n                        "
                              ),
                            ]),
                            _vm._v(" "),
                            _c(
                              "p",
                              { staticClass: "value" },
                              [
                                _c("a-rate", {
                                  staticStyle: { "font-size": "12px" },
                                  attrs: {
                                    value: _vm.statistics.avgRate,
                                    "allow-half": "",
                                    disabled: "",
                                  },
                                }),
                              ],
                              1
                            ),
                          ]
                        ),
                        _vm._v(" "),
                        _c(
                          "div",
                          {
                            staticClass: "box yes-hover",
                            on: {
                              click: function () {
                                this$1.tabIndex = 3
                                this$1.renderCalendar()
                              },
                            },
                          },
                          [
                            _c("p", { staticClass: "label" }, [
                              _vm._v(_vm._s(_vm.$t("message.workTime"))),
                            ]),
                            _vm._v(" "),
                            _c("p", { staticClass: "value" }, [
                              _vm._v(
                                "\n                            " +
                                  _vm._s(
                                    _vm._f("twoUnitTimeFilter")(
                                      _vm.statistics.workInfo.totalWorkTime,
                                      _vm.$i18n.locale
                                    )
                                  ) +
                                  "\n                        "
                              ),
                            ]),
                          ]
                        ),
                        _vm._v(" "),
                        _c(
                          "div",
                          {
                            staticClass: "box yes-hover",
                            on: {
                              click: function ($event) {
                                _vm.tabIndex = 2
                              },
                            },
                          },
                          [
                            _c("p", { staticClass: "label" }, [
                              _vm._v(
                                "\n                            " +
                                  _vm._s(_vm.$t("message.totalBreakNum")) +
                                  "\n                        "
                              ),
                            ]),
                            _vm._v(" "),
                            _c("p", { staticClass: "value" }, [
                              _vm._v(
                                "\n                            " +
                                  _vm._s(
                                    _vm.statistics.breakInfo.totalBreakCount
                                  ) +
                                  "\n                        "
                              ),
                            ]),
                          ]
                        ),
                        _vm._v(" "),
                        _c(
                          "div",
                          {
                            staticClass: "box yes-hover",
                            on: {
                              click: function ($event) {
                                _vm.tabIndex = 5
                              },
                            },
                          },
                          [
                            _c("p", { staticClass: "label" }, [
                              _vm._v(
                                "\n                            " +
                                  _vm._s(_vm.$t("message.personalRating")) +
                                  "\n                        "
                              ),
                            ]),
                            _vm._v(" "),
                            _c("p", { staticClass: "value" }),
                          ]
                        ),
                        _vm._v(" "),
                        _c(
                          "div",
                          {
                            staticClass: "box yes-hover",
                            on: {
                              click: function ($event) {
                                _vm.tabIndex = 6
                              },
                            },
                          },
                          [
                            _c("p", { staticClass: "label" }, [
                              _vm._v(
                                "\n                            " +
                                  _vm._s(
                                    _vm.$t("message.avgFirstMessageTime")
                                  ) +
                                  "\n                        "
                              ),
                            ]),
                            _vm._v(" "),
                            _c("p", { staticClass: "value" }, [
                              _vm._v(
                                "\n                            " +
                                  _vm._s(
                                    _vm._f("twoUnitTimeFilter")(
                                      _vm.statistics.avgFirstMessageTime,
                                      _vm.$i18n.locale
                                    )
                                  ) +
                                  "\n                        "
                              ),
                            ]),
                          ]
                        ),
                        _vm._v(" "),
                        _c(
                          "div",
                          {
                            staticClass: "box yes-hover",
                            on: {
                              click: function ($event) {
                                _vm.tabIndex = 7
                              },
                            },
                          },
                          [
                            _c("p", { staticClass: "label" }, [
                              _vm._v(
                                "\n                            " +
                                  _vm._s(_vm.$t("message.averageConTime")) +
                                  "\n                        "
                              ),
                            ]),
                            _vm._v(" "),
                            _c("p", { staticClass: "value" }, [
                              _vm._v(
                                "\n                            " +
                                  _vm._s(
                                    _vm._f("twoUnitTimeFilter")(
                                      _vm.statistics.avgChatDuration,
                                      _vm.$i18n.locale
                                    )
                                  ) +
                                  "\n                        "
                              ),
                            ]),
                          ]
                        ),
                        _vm._v(" "),
                        _c("div", { staticClass: "box no-shadow" }, [
                          _c("p", { staticClass: "label" }, [
                            _vm._v(
                              "\n                            " +
                                _vm._s(
                                  _vm.$t("message.totalWhatsappChatCount")
                                ) +
                                "\n                        "
                            ),
                          ]),
                          _vm._v(" "),
                          _c("p", { staticClass: "value" }, [
                            _vm._v(
                              "\n                            " +
                                _vm._s(_vm.statistics.totalWhatsappChatCount) +
                                "\n                        "
                            ),
                          ]),
                        ]),
                        _vm._v(" "),
                        _c("div", { staticClass: "box no-shadow" }, [
                          _c("p", { staticClass: "label" }, [
                            _vm._v(_vm._s(_vm.$t("message.chatBotEndStatics"))),
                          ]),
                          _vm._v(" "),
                          _vm.statistics.totalChatbotConversation > 0
                            ? _c("p", { staticClass: "value" }, [
                                _vm._v(
                                  "\n                            %" +
                                    _vm._s(_vm.calculateChatbotRate) +
                                    "\n                        "
                                ),
                              ])
                            : _c("p", { staticClass: "value" }, [_vm._v("-")]),
                        ]),
                        _vm._v(" "),
                        _c("div", { staticClass: "box no-shadow" }, [
                          _c("p", { staticClass: "label" }, [
                            _vm._v(_vm._s(_vm.$t("message.missedChat"))),
                          ]),
                          _vm._v(" "),
                          _c("p", { staticClass: "value" }, [
                            _vm._v(_vm._s(_vm.statistics.missedChat)),
                          ]),
                        ]),
                        _vm._v(" "),
                        _c("div", { staticClass: "box no-shadow" }, [
                          _c("p", { staticClass: "label" }, [
                            _vm._v(
                              "\n                            " +
                                _vm._s(_vm.$t("message.closedChatCount")) +
                                "\n                        "
                            ),
                          ]),
                          _vm._v(" "),
                          _c("p", { staticClass: "value" }, [
                            _vm._v(_vm._s(_vm.statistics.destroyedCount)),
                          ]),
                        ]),
                        _vm._v(" "),
                        _c("div", { staticClass: "box no-shadow" }, [
                          _c("p", { staticClass: "label" }, [
                            _vm._v(
                              "\n                            " +
                                _vm._s(_vm.$t("message.totalBreakTime")) +
                                "\n                        "
                            ),
                          ]),
                          _vm._v(" "),
                          _c("p", { staticClass: "value" }, [
                            _vm._v(
                              "\n                            " +
                                _vm._s(
                                  _vm._f("twoUnitTimeFilter")(
                                    _vm.statistics.breakInfo.totalBreakTime,
                                    _vm.$i18n.locale
                                  )
                                ) +
                                "\n                        "
                            ),
                          ]),
                        ]),
                        _vm._v(" "),
                        _c("div", { staticClass: "box no-shadow" }, [
                          _c("p", { staticClass: "label" }, [
                            _vm._v(
                              "\n                            " +
                                _vm._s(_vm.$t("message.shortestConTime")) +
                                "\n                        "
                            ),
                          ]),
                          _vm._v(" "),
                          _c("p", { staticClass: "value" }, [
                            _vm._v(
                              "\n                            " +
                                _vm._s(
                                  _vm._f("twoUnitTimeFilter")(
                                    _vm.statistics.minChatDuration,
                                    _vm.$i18n.locale
                                  )
                                ) +
                                "\n                        "
                            ),
                          ]),
                        ]),
                        _vm._v(" "),
                        _c("div", { staticClass: "box no-shadow" }, [
                          _c("p", { staticClass: "label" }, [
                            _vm._v(
                              "\n                            " +
                                _vm._s(_vm.$t("message.longestConTime")) +
                                "\n                        "
                            ),
                          ]),
                          _vm._v(" "),
                          _c("p", { staticClass: "value" }, [
                            _vm._v(
                              "\n                            " +
                                _vm._s(
                                  _vm._f("twoUnitTimeFilter")(
                                    _vm.statistics.maxChatDuration,
                                    _vm.$i18n.locale
                                  )
                                ) +
                                "\n                        "
                            ),
                          ]),
                        ]),
                      ]),
                      _vm._v(" "),
                      _c("b-col", { attrs: { lg: "8" } }, [
                        _c(
                          "div",
                          {
                            directives: [
                              {
                                name: "show",
                                rawName: "v-show",
                                value: _vm.tabIndex === 0,
                                expression: "tabIndex === 0",
                              },
                            ],
                            staticClass: "custom-card-report",
                          },
                          [
                            _c("h5", [
                              _vm._v(_vm._s(_vm.$t("message.statsByTime"))),
                            ]),
                            _vm._v(" "),
                            _c("ECharts", {
                              ref: "chart",
                              staticStyle: { height: "calc(100vh - 200px)" },
                              attrs: { id: "chart-1", option: _vm.bar },
                            }),
                          ],
                          1
                        ),
                        _vm._v(" "),
                        _c(
                          "div",
                          {
                            directives: [
                              {
                                name: "show",
                                rawName: "v-show",
                                value: _vm.tabIndex === 2,
                                expression: "tabIndex === 2",
                              },
                            ],
                            staticClass: "custom-card-report",
                          },
                          [
                            _c("h5", [
                              _vm._v(_vm._s(_vm.$t("message.breaksByTime"))),
                            ]),
                            _vm._v(" "),
                            _c("ECharts", {
                              ref: "chart",
                              staticStyle: { height: "calc(100vh - 200px)" },
                              attrs: { id: "chart-4", option: _vm.barBreak },
                            }),
                          ],
                          1
                        ),
                        _vm._v(" "),
                        _c(
                          "div",
                          {
                            directives: [
                              {
                                name: "show",
                                rawName: "v-show",
                                value: _vm.tabIndex === 1,
                                expression: "tabIndex === 1",
                              },
                            ],
                            staticClass: "custom-card-report",
                          },
                          [
                            _c("h5", [
                              _vm._v(_vm._s(_vm.$t("message.statsByTime"))),
                            ]),
                            _vm._v(" "),
                            Object.keys(_vm.statistics.ratingHistogram).length
                              ? _c("ECharts", {
                                  ref: "chart",
                                  staticStyle: {
                                    height: "calc(100vh - 200px)",
                                  },
                                  attrs: { id: "chart-3", option: _vm.point },
                                })
                              : _c("a-result", {
                                  attrs: {
                                    title: _vm.$t("message.noRating"),
                                    status: "warning",
                                  },
                                }),
                          ],
                          1
                        ),
                        _vm._v(" "),
                        _c(
                          "div",
                          {
                            directives: [
                              {
                                name: "show",
                                rawName: "v-show",
                                value: _vm.tabIndex === 3,
                                expression: "tabIndex === 3",
                              },
                            ],
                            staticClass: "custom-card-report",
                          },
                          [
                            ["today", "yesterday"].includes(
                              _vm.customDateFilter
                            )
                              ? _c(
                                  "div",
                                  [
                                    _c("ECharts", {
                                      staticStyle: {
                                        height: "calc(100vh - 100px)",
                                      },
                                      attrs: { option: _vm.barY },
                                    }),
                                  ],
                                  1
                                )
                              : _c(
                                  "div",
                                  { staticClass: "moreThanDay" },
                                  [
                                    _c("h5", [
                                      _vm._v(_vm._s(_vm.calendarTitle)),
                                    ]),
                                    _vm._v(" "),
                                    _c(
                                      "b-form-group",
                                      {
                                        staticClass: "mb-1",
                                        staticStyle: {
                                          "align-self": "flex-end",
                                        },
                                      },
                                      [
                                        _c(
                                          "b-form-select",
                                          {
                                            staticClass: "mb-3",
                                            model: {
                                              value: _vm.selectedCalendarUser,
                                              callback: function ($$v) {
                                                _vm.selectedCalendarUser = $$v
                                              },
                                              expression:
                                                "selectedCalendarUser",
                                            },
                                          },
                                          _vm._l(
                                            _vm.calendarUsers,
                                            function (user) {
                                              return _c(
                                                "option",
                                                {
                                                  key: user._id,
                                                  domProps: { value: user._id },
                                                },
                                                [
                                                  _vm._v(
                                                    "\n                                        " +
                                                      _vm._s(user.name) +
                                                      "\n                                    "
                                                  ),
                                                ]
                                              )
                                            }
                                          ),
                                          0
                                        ),
                                      ],
                                      1
                                    ),
                                    _vm._v(" "),
                                    _c("ECharts", {
                                      ref: "calendar",
                                      staticStyle: {
                                        height: "calc(100vh - 100px)",
                                      },
                                      attrs: {
                                        id: "calendar",
                                        option: _vm.calendar,
                                      },
                                    }),
                                  ],
                                  1
                                ),
                          ]
                        ),
                        _vm._v(" "),
                        _c(
                          "div",
                          {
                            directives: [
                              {
                                name: "show",
                                rawName: "v-show",
                                value: _vm.tabIndex === 4,
                                expression: "tabIndex === 4",
                              },
                            ],
                            staticClass: "custom-card-report",
                          },
                          [
                            _c("h5", [
                              _vm._v(
                                _vm._s(_vm.$t("message.distConversation"))
                              ),
                            ]),
                            _vm._v(" "),
                            Object.keys(_vm.statistics.userChatHistogram).length
                              ? _c("ECharts", {
                                  ref: "chart",
                                  staticStyle: {
                                    height: "calc(100vh - 200px)",
                                  },
                                  attrs: { id: "chart-2", option: _vm.pie },
                                })
                              : _c("a-result", {
                                  attrs: {
                                    title: _vm.$t("message.chatNotFound"),
                                    status: "warning",
                                  },
                                }),
                          ],
                          1
                        ),
                        _vm._v(" "),
                        _c(
                          "div",
                          {
                            directives: [
                              {
                                name: "show",
                                rawName: "v-show",
                                value: _vm.tabIndex === 20,
                                expression: "tabIndex === 20",
                              },
                            ],
                            staticClass: "custom-card-report",
                          },
                          [
                            _c("h5", [
                              _vm._v(_vm._s(_vm.$t("message.videoCallDist"))),
                            ]),
                            _vm._v(" "),
                            Object.keys(_vm.statistics.userChatHistogram).length
                              ? _c("ECharts", {
                                  ref: "chart",
                                  staticStyle: {
                                    height: "calc(100vh - 200px)",
                                  },
                                  attrs: {
                                    id: "chart-20",
                                    option: _vm.videoCallPie,
                                  },
                                })
                              : _c("a-result", {
                                  attrs: {
                                    title: _vm.$t("message.chatNotFound"),
                                    status: "warning",
                                  },
                                }),
                          ],
                          1
                        ),
                        _vm._v(" "),
                        _c(
                          "div",
                          {
                            directives: [
                              {
                                name: "show",
                                rawName: "v-show",
                                value: _vm.tabIndex === 5,
                                expression: "tabIndex === 5",
                              },
                            ],
                            staticClass: "custom-card-report",
                          },
                          [
                            _c("h5", [
                              _vm._v(_vm._s(_vm.$t("message.personalRating"))),
                            ]),
                            _vm._v(" "),
                            Object.keys(_vm.statistics.userRateHistogram).length
                              ? _c("ECharts", {
                                  ref: "chart",
                                  staticStyle: {
                                    height: "calc(100vh - 200px)",
                                  },
                                  attrs: {
                                    id: "chart-5",
                                    option: _vm.pieBorder,
                                  },
                                })
                              : _vm._e(),
                          ],
                          1
                        ),
                        _vm._v(" "),
                        _c(
                          "div",
                          {
                            directives: [
                              {
                                name: "show",
                                rawName: "v-show",
                                value: _vm.tabIndex === 6,
                                expression: "tabIndex === 6",
                              },
                            ],
                            staticClass: "custom-card-report",
                          },
                          [
                            _c("h5", [
                              _vm._v(
                                _vm._s(_vm.$t("message.personalFirstMsg"))
                              ),
                            ]),
                            _vm._v(" "),
                            Object.keys(_vm.statistics.userFirstMsgHistogram)
                              .length
                              ? _c("ECharts", {
                                  ref: "chart",
                                  staticStyle: {
                                    height: "calc(100vh - 200px)",
                                  },
                                  attrs: { id: "chart-6", option: _vm.line },
                                })
                              : _vm._e(),
                          ],
                          1
                        ),
                        _vm._v(" "),
                        _c(
                          "div",
                          {
                            directives: [
                              {
                                name: "show",
                                rawName: "v-show",
                                value: _vm.tabIndex === 7,
                                expression: "tabIndex === 7",
                              },
                            ],
                            staticClass: "custom-card-report",
                          },
                          [
                            _c("h5", [
                              _vm._v(_vm._s(_vm.$t("message.averageConTime"))),
                            ]),
                            _vm._v(" "),
                            Object.keys(_vm.statistics.userAvgChatDuration)
                              .length
                              ? _c("ECharts", {
                                  ref: "chart",
                                  staticStyle: {
                                    height: "calc(100vh - 200px)",
                                  },
                                  attrs: {
                                    id: "chart-7",
                                    option: _vm.userAvgChatDuration,
                                  },
                                })
                              : _vm._e(),
                          ],
                          1
                        ),
                      ]),
                    ],
                    1
                  ),
                ],
                1
              )
            : _c("md-progress-spinner", {
                staticStyle: { position: "absolute", left: "45%", top: "50%" },
                attrs: {
                  "md-diameter": 100,
                  "md-stroke": 10,
                  "md-mode": "indeterminate",
                },
              }),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }